import React from 'react';

import Footer from '../../components/layout/Footer';
import PublicNavbar from '../../components/layout/PublicNavbar';
import CTASection from './sections/CTASection';
import ForRolesSection from './sections/ForRolesSection';
import HeroSection from './sections/HeroSection';
import HowItWorksSection from './sections/HowItWorksSection';
import ImpactSection from './sections/ImpactSection';
import ProjectsSection from './sections/ProjectsSection';
import WhyAtharvaSection from './sections/WhyAtharvaSection';

export default function AtharvaLanding() {
  return (
    <div className="overflow-x-hidden bg-white text-gray-900">
      <PublicNavbar />
      <HeroSection />
      <WhyAtharvaSection />
      <HowItWorksSection />
      <ForRolesSection />
      <ImpactSection />
      <ProjectsSection />
      <CTASection />
      <Footer />
    </div>
  );
}
